import qs from 'query-string'
import { QS_CONFIG } from 'Utilities'

export function parsedSearch(search) {
    const ps = qs.parse(search, QS_CONFIG)
    const rebuiltKeyword = (ps.keyword || '')
        .split(',')
        .concat(ps.brand)
        .concat(ps.model)
        .concat(ps.patente)
        .filter(e => e)
        .join(',')

    ps.keyword = rebuiltKeyword || undefined
    return ps
}
